import React, { useEffect } from 'react';
import { BdsTypo } from 'blip-ds/dist/blip-ds-react';
import { useAiTokenConsumptionContext } from '../../../../contexts/Billing/AiTokenConsumptionContext';
import { useAiTokenConsumptionDataContext } from '../../../../contexts/Billing/AiTokenConsumptionDataContext';
import { PageHeaderComponent } from '../../components/Metrics/PageHeader/PageHeaderComponent';
import { ConsolidatedHeaderComponent } from '../../components/Metrics/ConsolidatedHeader/ConsolidatedHeaderComponent';
import { AiTokenConsumptionPaper, TitleContainer, Divider, MetricCardItem } from '../styles';
import { BlipLoadingComponent } from '../../../../components/BlipLoading/BlipLoadingComponent';
import { trackEvent } from '../../../../api/Billing/Tracking';
import { REPORT_PERIOD_SELECT } from '../../../../shared/SegmentEvents';

const AiTokenConsumptionUsage: React.FC = () => {
  const { content, dateToSearch, periodOptions, setDateToSearch, currentMonth, tenant, loggedUser, trackingProps, getPlanStatus } =
    useAiTokenConsumptionContext();
  const { totalAiTokenConsumption, containsDataOnSelectedMonth, isAiTokenLoading, consolidatedAiTokenApiRequisition } =
    useAiTokenConsumptionDataContext();

  useEffect(() => {
    consolidatedAiTokenApiRequisition(dateToSearch);
  }, [dateToSearch, consolidatedAiTokenApiRequisition]);

  const periodOptionChangeEvent = async (selectedOption) => {
    const dateToRetrieveData = new Date(selectedOption.detail.value);
    setDateToSearch(dateToRetrieveData);
    const planStatus = await getPlanStatus();
    trackEvent(REPORT_PERIOD_SELECT, tenant, loggedUser, {
      ...trackingProps,
      date: dateToRetrieveData,
      planStatus,
    });
  };

  return (
    <>
      <PageHeaderComponent
        title={content.title}
        dateToSearch={dateToSearch}
        periodOptions={periodOptions}
        periodOptionChangeEvent={periodOptionChangeEvent}
      />
      <AiTokenConsumptionPaper>
        <TitleContainer>
          <ConsolidatedHeaderComponent
            infoHeader={content.compiledInformation.plan}
            dateToSearch={dateToSearch}
            currentMonth={currentMonth}
            showConsolidatedBorder={false}
            middleInfoContent={content.compiledInformation.disclaimer}
          />
        </TitleContainer>
        <Divider />
        {isAiTokenLoading ? (
          <BlipLoadingComponent />
        ) : (
          <MetricCardItem>
            <BdsTypo variant="fs-16" bold="bold" margin={false} style={{ marginBottom: '8px' }}>
              {content.compiledInformation.totalTokensLabel}
            </BdsTypo>
            <BdsTypo variant="fs-32" bold="bold" margin={false}>
              {containsDataOnSelectedMonth ? totalAiTokenConsumption.aiTokenTotal.toLocaleString(content.locale) : '--'}
            </BdsTypo>
          </MetricCardItem>
        )}
      </AiTokenConsumptionPaper>
    </>
  );
};

export default AiTokenConsumptionUsage;
